import { useState } from 'react';

const EMPTY = {
  userName: '', userId: '', password: '', email: '',
  address: '', contactnumber: '', role: '', bstatus: '',
};

export default function UserRegistration() {
  const [form, setForm]       = useState(EMPTY);
  const [saving, setSaving]   = useState(false);
  const [msg, setMsg]         = useState(null);   // { text, ok }
  const [showPwd, setShowPwd] = useState(false);

  const set = (k, v) => setForm(f => ({ ...f, [k]: v }));

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!/^[0-9]{10}$/.test(form.contactnumber)) {
      setMsg({ text: 'Contact number must be exactly 10 digits.', ok: false });
      return;
    }

    setSaving(true);
    setMsg(null);
    try {
      const timestamp = Date.parse(new Date());
      const res = await fetch(`/spring/registeremployee/${timestamp}`, {
        method: 'POST',
        credentials: 'include',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'empRegistrationData=' + encodeURIComponent(JSON.stringify(form)),
      });

      const text = await res.text();

      if (res.status === 444) {
        window.location.href = '/spring/login';
        return;
      }
      if (res.status === 500) {
        setMsg({ text: 'Registration failed — Login ID already exists. Please use a different Login ID.', ok: false });
        return;
      }

      const ok = text === 'Employee registration successful';
      if (ok) {
        window.location.reload();
        return;
      }
      setMsg({ text, ok: false });
    } catch (err) {
      setMsg({ text: 'Network error: ' + err.message, ok: false });
    } finally {
      setSaving(false);
    }
  };

  return (
    <div style={{ maxWidth: 540, margin: '0 auto' }}>
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            <i className="fas fa-user-plus" style={{ marginRight: 8, color: '#0066CC' }}></i>
            User Registration
          </div>
        </div>
        <div className="card-body">

          {msg && (
            <div
              className={msg.ok ? 'success-msg' : 'error-msg'}
              style={{ marginBottom: 16, display: 'flex', alignItems: 'flex-start', gap: 10 }}
            >
              <i className={`fas ${msg.ok ? 'fa-check-circle' : 'fa-exclamation-triangle'}`}
                 style={{ marginTop: 2, flexShrink: 0 }}></i>
              <span>{msg.text}</span>
            </div>
          )}

          <form onSubmit={handleSubmit} noValidate>
            <div className="table-wrap" style={{ marginBottom: 16 }}>
              <table style={{ width: '100%', borderCollapse: 'collapse', fontSize: 14 }}>
                <thead>
                  <tr>
                    <th colSpan={2} style={{ background: '#0066CC', color: '#fff', padding: '10px 14px', textAlign: 'center', fontWeight: 700 }}>
                      Registration Details
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {/* User Name */}
                  <tr>
                    <td style={labelStyle}>
                      <i className="fas fa-user" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Full Name *
                    </td>
                    <td style={cellStyle}>
                      <input
                        className="form-control"
                        type="text"
                        value={form.userName}
                        onChange={e => set('userName', e.target.value)}
                        maxLength={200}
                        placeholder="Full name"
                        required
                        autoComplete="off"
                      />
                    </td>
                  </tr>

                  {/* Login ID */}
                  <tr style={{ background: '#f5f9ff' }}>
                    <td style={labelStyle}>
                      <i className="fas fa-id-badge" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Login ID *
                    </td>
                    <td style={cellStyle}>
                      <input
                        className="form-control"
                        type="text"
                        value={form.userId}
                        onChange={e => set('userId', e.target.value)}
                        maxLength={200}
                        placeholder="Unique login username"
                        required
                        autoComplete="off"
                      />
                    </td>
                  </tr>

                  {/* Password */}
                  <tr>
                    <td style={labelStyle}>
                      <i className="fas fa-lock" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Password *
                    </td>
                    <td style={cellStyle}>
                      <div style={{ position: 'relative' }}>
                        <input
                          className="form-control"
                          type={showPwd ? 'text' : 'password'}
                          value={form.password}
                          onChange={e => set('password', e.target.value)}
                          maxLength={200}
                          placeholder="Password"
                          required
                          autoComplete="new-password"
                          style={{ paddingRight: 40 }}
                        />
                        <button
                          type="button"
                          onClick={() => setShowPwd(p => !p)}
                          style={{ position: 'absolute', right: 10, top: '50%', transform: 'translateY(-50%)', background: 'none', border: 'none', cursor: 'pointer', color: '#718096', fontSize: 13 }}
                          tabIndex={-1}
                        >
                          <i className={`fas ${showPwd ? 'fa-eye-slash' : 'fa-eye'}`}></i>
                        </button>
                      </div>
                    </td>
                  </tr>

                  {/* Email */}
                  <tr style={{ background: '#f5f9ff' }}>
                    <td style={labelStyle}>
                      <i className="fas fa-envelope" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Email ID *
                    </td>
                    <td style={cellStyle}>
                      <input
                        className="form-control"
                        type="email"
                        value={form.email}
                        onChange={e => set('email', e.target.value)}
                        maxLength={200}
                        placeholder="email@example.com"
                        required
                        autoComplete="off"
                      />
                    </td>
                  </tr>

                  {/* Address */}
                  <tr>
                    <td style={labelStyle}>
                      <i className="fas fa-map-marker-alt" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Contact Address *
                    </td>
                    <td style={cellStyle}>
                      <textarea
                        className="form-control"
                        value={form.address}
                        onChange={e => set('address', e.target.value)}
                        rows={3}
                        placeholder="Full address"
                        required
                        autoComplete="off"
                        style={{ resize: 'vertical', minHeight: 72 }}
                      />
                    </td>
                  </tr>

                  {/* Contact Number */}
                  <tr style={{ background: '#f5f9ff' }}>
                    <td style={labelStyle}>
                      <i className="fas fa-phone" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Contact Number *
                    </td>
                    <td style={cellStyle}>
                      <input
                        className="form-control"
                        type="tel"
                        value={form.contactnumber}
                        onChange={e => set('contactnumber', e.target.value.replace(/\D/g, '').slice(0, 10))}
                        maxLength={10}
                        placeholder="10-digit mobile number"
                        required
                        autoComplete="off"
                      />
                    </td>
                  </tr>

                  {/* Role */}
                  <tr>
                    <td style={labelStyle}>
                      <i className="fas fa-user-tag" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Role *
                    </td>
                    <td style={cellStyle}>
                      <select
                        className="form-control"
                        value={form.role}
                        onChange={e => set('role', e.target.value)}
                        required
                      >
                        <option value="">-- Select Role --</option>
                        <option value="11">Student</option>
                        <option value="12">Teacher</option>
                      </select>
                    </td>
                  </tr>

                  {/* Status */}
                  <tr style={{ background: '#f5f9ff' }}>
                    <td style={labelStyle}>
                      <i className="fas fa-toggle-on" style={{ marginRight: 6, color: '#0066CC' }}></i>
                      Status *
                    </td>
                    <td style={cellStyle}>
                      <select
                        className="form-control"
                        value={form.bstatus}
                        onChange={e => set('bstatus', e.target.value)}
                        required
                      >
                        <option value="">-- Select Status --</option>
                        <option value="ACTIVE">ACTIVE</option>
                        <option value="DISABLE">DISABLE</option>
                      </select>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <button
              type="submit"
              className="btn btn-primary"
              disabled={saving}
              style={{ width: '100%', padding: '12px', fontSize: 15, fontWeight: 700, justifyContent: 'center' }}
            >
              {saving
                ? <><i className="fas fa-spinner fa-spin" style={{ marginRight: 8 }}></i>Registering…</>
                : <><i className="fas fa-save" style={{ marginRight: 8 }}></i>Register</>
              }
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}

const labelStyle = {
  padding: '10px 14px',
  borderBottom: '1px solid #eee',
  verticalAlign: 'middle',
  fontWeight: 600,
  color: '#555',
  whiteSpace: 'nowrap',
  width: '38%',
  fontSize: 13,
};

const cellStyle = {
  padding: '8px 14px',
  borderBottom: '1px solid #eee',
  verticalAlign: 'middle',
};
